
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="200" height="200" class="icon" viewBox="0 0 1024 1024"><path d="M304.393 472.813c-15.4-16.4-39.4-15.4-49.6 5.6L3.2 980.401c-10 20 4.8 43.399 26.8 43.399h349.99c11.6.2 22-6.4 26.8-16.8 75.798-155.596 30.2-392.59-102.397-534.186zM488.788 16.225c-244.594 386.79-17 697.183 129.997 990.975 5 10.2 15.4 16.8 26.8 16.8h348.39c22.4 0 36.8-23.6 26.8-43.399 0 0-468.989-941.177-480.788-964.576-10.6-21.2-37.6-21.6-51.199.2z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    